import { useSorts } from "../../Common/Hooks/useSorts"
import Sorting from "../Sorting"
import { LocationLink } from "../Filtering/LocationLink"
import { Play } from "../../Common/SI"
import { SortToggle } from "../SortToggle"
import React from "react"

export interface LocationOutcomeTableProps {
	plays: Play[]
	locations: string[]
}

export const LocationOutcomeTable = React.memo(function (props: LocationOutcomeTableProps): JSX.Element {

	const table = 'LocationOutcome'

	const { sorts } = useSorts()
	const sort = sorts.get(table) || { field: 'location', ascending: true }

	const rowByLocation: Map<string, TableRow> = new Map()

	for (const location of props.locations) {
		rowByLocation.set(location, {
			location,
			lossCount: 0,
			playCount: null,
			winCount: 0,
			winRate: null,
		})
	}

	for (const play of props.plays) {
		const row = rowByLocation.get(play.location)
		if (!row) {
			continue
		}

		if (play.outcome.victory) {
			row.winCount++
		} else {
			row.lossCount++
		}
	}

	const tableData = Array.from(rowByLocation.values())
	for (const row of tableData) {
		row.playCount = (row.winCount + row.lossCount) || null
		if (row.playCount) {
			row.winRate = row.winCount / row.playCount
		}
	}

	Sorting.sort(tableData, sort, 'location')

	return (
		<div>
			<table className="stats location-outcomes">
				<thead>
					<tr>
						<th>
							<SortToggle table={table} field={'location'} label='Location' defaultAscending={true} />
						</th>
						<th>
							<SortToggle table={table} field={'winCount'} label='W' />
						</th>
						<th>
							<SortToggle table={table} field={'lossCount'} label='L' />
						</th>
						<th>
							<SortToggle table={table} field={'playCount'} label='Total' />
						</th>
						<th>
							<SortToggle table={table} field={'winRate'} label='Win %' />
						</th>
					</tr>
				</thead>
				<tbody>
					{
						tableData.map(row =>
							<tr key={row.location}>
								<th><LocationLink location={row.location} /></th>
								<td className='victory'>{row.winCount || ''}</td>
								<td className='loss'>{row.lossCount || ''}</td>
								<td>{row.playCount || ''}</td>
								<td>{row.winRate ? `${(100 * row.winRate).toFixed(1)}%` : ''}</td>
							</tr>
						)
					}
				</tbody>
			</table>
		</div>
	)
})

interface TableRow {
	location: string
	lossCount: number
	playCount: number | null
	winCount: number
	winRate: number | null
}
